<template>
  <div class="page-content-wrapper">
    <div class="content">
      <div class="container-fluid container-fixed-lg">
        <div class="row p-3">
          <div class="col-lg-12">
            <h2 class="text-dag">{{ $t('profile_login_fail') }}</h2>
          </div>
        </div>

        <div class="row">
          <div class="col-lg-6 m-b-10">
            <div class="card no-border widget-loader-circle no-padding rounded">
              <div class="card-body p-t-25 p-b-30">
                <form>
                  <div class="form-group contact">
                    <label for="email">
                      <p class="adviestitle">{{ $t('profile_email') }}</p>
                    </label>
                    <b-form-input type="email"
                           class="form-control form-control-lg"
                           id="email"
                                  v-model="form.EmailAddress"
                           :placeholder="$t('profile_email')"/>
                  </div>
                </form>
                  <button class="advicebutton text-white confirm"
                  @click="submit">
                    {{ $t('profile_send_link') }}
                  </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    computed: {},
    methods: {
      submit() {
        this.$http.post('user/sendlink', this.form).then(response => {
          this.$router.push({ name: 'login' })
        }, error => {
          console.log(error)
          alert(error.statusText)
        })
      },
    },
    data() {
      return {
        form: {
          EmailAddress: ''
        }
      }
    },
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/profile/ResetPassword.vue